'use client';

import React, { memo, useMemo } from 'react';
import Image from 'next/image';

interface AppLogoProps {
  src?: string;
  text?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  priority?: boolean;
}

const AppLogo = memo(function AppLogo({
  src = '/assets/images/image-1778410930765.png',
  text,
  iconName = 'SparklesIcon',
  size = 64,
  className = '',
  onClick,
  priority = false,
}: AppLogoProps) {
  const containerClassName = useMemo(() => {
    const classes = ['flex items-center gap-2'];
    if (onClick) classes.push('cursor-pointer hover:opacity-80 transition-opacity');
    if (className) classes.push(className);
    return classes.join(' ');
  }, [onClick, className]);

  // Horizontal logo: real ratio is approximately 5:1 (wide logo)
  // Display height derived from size prop, width calculated from ratio
  const displayHeight = Math.round(size * 0.5);
  const displayWidth = Math.round(displayHeight * 5);

  return (
    <div className={containerClassName} onClick={onClick}>
      <Image
        src={src}
        alt="EFX E-Foil Experience logo"
        width={displayWidth}
        height={displayHeight}
        priority={priority}
        style={{ objectFit: 'contain', width: 'auto', height: `${displayHeight}px` }}
      />
      {text && <span className="text-xl font-bold">{text}</span>}
    </div>
  );
});

export default AppLogo;